import { Pipe, PipeTransform } from '@angular/core';

/**
 * A pipe which transforms a string identifier for a bookmaker, into a URL string for the image file of that
 * bookmaker's full logo.
 */
@Pipe({
  name: 'bookLogo'
})
export class BookLogoPipe implements PipeTransform {

  /**
   * A pipe which transforms a string identifier for a bookmaker, into a URL string for the image file of that
   * bookmaker's full logo.
   * @param bookName the identifier code for the bookmaker object, as returned by the sport data APIs
   * @returns a URL to a full logo image for the corresponding bookmaker, or an empty string if the identifier
   * does not match one of the recognised identifiers
   */
  transform(bookName: string): string {
    switch (bookName?.toLowerCase()) {
      case "betstreet":
        return "https://content-blocks-node.azurewebsites.net/static/assets/betstreet-full-logo.svg";
      case "fanduel":
        return "https://content-blocks-node.azurewebsites.net/static/assets/fanduel-full-logo.svg";
      case "sugarhouse":
        return "https://content-blocks-node.azurewebsites.net/static/assets/sugarhouse-full-logo.png";
      case "pointsbet":
        return "https://content-blocks-node.azurewebsites.net/static/assets/pointsbet-full-logo.png";
      case "pointsbet_au":
        return "https://cdn.ciphersports.io/images/bookmaker-images/pointsbet-full-logo-sloganless.png";
      case "william_hill":
        return "https://content-blocks-node.azurewebsites.net/static/assets/william-hill-full-logo.png";
      case "draftkings":
        return "https://content-blocks-node.azurewebsites.net/static/assets/draftkings-full-logo.svg";
      case "wynn":
        return "https://cdn.ciphersports.io/images/bookmaker-images/wynnbet-full-logo.png";
      case "betmgm":
        return "https://content-blocks-node.azurewebsites.net/static/assets/betmgm-full-logo.png";
      case "bet_rivers_in":
      case "bet_rivers_va":
      case "bet_rivers_co":
        return "https://content-blocks-node.azurewebsites.net/static/assets/bet-rivers-full-logo.png";
      case "bet365":
      case "bet_365":
        return "https://content-blocks-node.azurewebsites.net/static/assets/bet365-full-logo.svg";
      case "betway":
        return "https://content-blocks-node.azurewebsites.net/static/assets/betway-full-logo.png";
      case "unibet":
        return "https://content-blocks-node.azurewebsites.net/static/assets/unibet-full-logo.png";
      case "tipico":
        return "https://content-blocks-node.azurewebsites.net/static/assets/tipico-full-logo.png";
      case "twinspires":
        return "https://content-blocks-node.azurewebsites.net/static/assets/twinspires-full-logo.png";
      case "bluebet":
        return "https://content-blocks-node.azurewebsites.net/static/assets/bluebet-full-logo.svg";
      case "topsport":
        return "https://content-blocks-node.azurewebsites.net/static/assets/topsport-full-logo.svg";
      case "betfair":
        return "https://content-blocks-node.azurewebsites.net/static/assets/betfair-full-logo.svg";
      default:
        return ""
    }
  }

}
